/* Copyright (c) 2020 Paul Nebel */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import {
    Slider,
    Slide,
    ButtonBack,
    ButtonNext,
    DotGroup,
    WithStore,
} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

import ChordSymbol from '../components/chord-symbol';
import ChordStave from '../components/chord-stave';
import PianoKeys from '../components/piano-keys';
// import ChordTab from '../components/chord-tab';
// import ChordChart from '../components/chord-chart';

class ViewerCarousel extends React.Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        const { metronomeState } = nextProps;

        const newState = {
            ...prevState,
        };

        switch (metronomeState) {
            // case 'intro':
            // case 'pausedActive':
            // newState.backgroundColor = '#8ca4c0';
            // newState.backgroundColor = '#F0AD4E';
            // newState.color = '#0A0A0A';
            // break;
            case 'active':
                newState.backgroundColor = '#dee5ed';
                newState.color = '#0A0A0A';
                // newState.backgroundColor = '#5CB85C';
                break;
            default:
                newState.backgroundColor = '#2B3E50';
                // newState.backgroundColor = '#D9534F';
                newState.color = '#dee5ed';
        }

        if (!isEqual(prevState, newState)) {
            return newState;
        } else {
            return null;
        }
    }

    constructor(props) {
        super(props);
        this.handleOnClick = this.handleOnClick.bind(this);
        this.state = {
            backgroundColor: '#2B3E50',
            color: '#dee5ed',
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            !isEqual(nextProps.children, this.props.children) ||
            !isEqual(
                this.props.carouselStore.getState,
                nextProps.carouselStore.getState
            ) ||
            this.state.backgroundColor !== nextState.backgroundColor
        );
    }

    handleOnClick(idx) {
        const { carouselStore } = this.props;

        carouselStore.setStoreState({
            currentSlide: idx,
            isPlaying: false,
        });
    }
    render() {
        const renderDots = (args) => {
            const { totalSlides, currentSlide } = args;
            const dots = [];

            for (let i = 0; i < totalSlides; i += 1) {
                if (i === currentSlide) {
                    dots.push(
                        <div
                            key={i}
                            className="ml-1 mr-1"
                            style={{
                                display: 'inline-block',
                                height: '5px',
                                width: '25%',
                                backgroundColor: 'white',
                            }}
                        ></div>
                    );
                } else {
                    dots.push(
                        <div
                            key={i}
                            className="ml-1 mr-1"
                            style={{
                                display: 'inline-block',
                                height: '5px',
                                width: '25%',
                                backgroundColor: '#3E4B59',
                            }}
                            onClick={() => this.handleOnClick(i)}
                        ></div>
                    );
                }
            }
            return dots;
        };

        const bgColor = this.state.backgroundColor;
        const tColor = this.state.color;

        return (
            <div>
                <div style={{ position: 'relative' }}>
                    <Slider>
                        <Slide index={0}>
                            <div
                                className="card p-0"
                                style={{
                                    borderRadius: '.5rem',
                                    backgroundColor: bgColor,
                                }}
                            >
                                <div className="card-content p-0 is-flex is-justify-content-center">
                                    <ChordSymbol
                                        chordSymbol="C"
                                        font="140px sans-serif"
                                        x={40}
                                        y={15}
                                        backgroundColor={bgColor}
                                        color={tColor}
                                        height={160}
                                    />
                                </div>
                            </div>
                        </Slide>
                        <Slide index={1}>
                            <div
                                className="card p-0"
                                style={{
                                    borderRadius: '.5rem',
                                    backgroundColor: bgColor,
                                }}
                            >
                                <div className="card-content p-0 is-flex is-justify-content-center">
                                    <ChordStave
                                        chordSymbol="C"
                                        width={320}
                                        height={160}
                                        staveWidth={130}
                                        staveX={25}
                                        staveY={-20}
                                        addKey={false}
                                        scale={1.8}
                                    />
                                </div>
                            </div>
                        </Slide>
                        <Slide index={2}>
                            <div
                                className="card p-0 pt-5"
                                style={{
                                    borderRadius: '.5rem',
                                    backgroundColor: bgColor,
                                    height: 160,
                                }}
                            >
                                <div className="card-content p-0 is-flex is-justify-content-center">
                                    <PianoKeys chordSymbol="C" />
                                </div>
                            </div>
                        </Slide>
                        {/* <Slide index={ 3 }>
                            <div className='card p-0 pt-5' style={{ borderRadius: '.5rem', backgroundColor: bgColor }}>
                                <div className='card-content p-0 is-flex is-justify-content-center'>
                                    <ChordTab
                                        chordSymbol='C'
                                    />
                                </div>
                            </div>
                        </Slide>
                        <Slide index={ 3 }>
                            <div className='card p-0 pt-5' style={{ borderRadius: '.5rem', backgroundColor: bgColor }}>
                                <div className='card-content p-0 is-flex is-justify-content-center'>
                                    <ChordChart
                                        chordSymbol='C'
                                    />
                                </div>
                            </div>
                        </Slide> */}
                    </Slider>
                    <ButtonBack
                        className="is-hidden-mobile"
                        style={{
                            position: 'absolute',
                            top: '73px',
                            left: '-10px',
                        }}
                    >
                        <i className="fas fa-chevron-left"></i>
                    </ButtonBack>
                    <ButtonNext
                        className="is-hidden-mobile"
                        style={{
                            position: 'absolute',
                            top: '73px',
                            right: '-10px',
                        }}
                    >
                        <i className="fas fa-chevron-right"></i>
                    </ButtonNext>
                    <DotGroup
                        renderDots={renderDots}
                        style={{
                            position: 'absolute',
                            top: '160px',
                            width: '100%',
                        }}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ metronomeState }) => {
    return {
        metronomeState,
    };
};

ViewerCarousel.propTypes = {
    metronomeState: PropTypes.string,
    carouselStore: PropTypes.object.isRequired,
    children: PropTypes.object,
};

export default connect(mapStateToProps)(WithStore(ViewerCarousel));
